import { render } from "./AnswerPageFour.vue?vue&type=template&id=7b5bea97&scoped=true"
import script from "./AnswerPageFour.vue?vue&type=script&lang=js"
export * from "./AnswerPageFour.vue?vue&type=script&lang=js"

import "./AnswerPageFour.vue?vue&type=style&index=0&id=7b5bea97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5bea97"]])

export default __exports__